import React from 'react'

import { SecondaryNavLayout } from 'src/modules/ui'

import AddProduct from './AddProduct'
import EditProduct from './EditProduct'
import ProductList from './ProductList'

const Products = () => {
  const routes = [
    {
      path: '/products/',
      exact: true,
      component: ProductList,
      title: 'Products',
    },
    {
      path: '/products/add/',
      component: AddProduct,
      title: 'Add Product',
    },
    {
      path: '/products/:id/',
      component: EditProduct,
      title: 'Edit Product',
    },
  ]
  return <SecondaryNavLayout routes={routes} />
}

export default Products
